import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import FeatureFlagWebClient from '@atlassiansox/feature-flag-web-client';
import * as Immutable from 'immutable';
import FrontendFeatureFlagsMockClient from "./FrontendFeatureFlagsMockClient";
export var FeatureFlags = /*#__PURE__*/function () {
  function FeatureFlags(client, userIdentifier) {
    _classCallCheck(this, FeatureFlags);

    _defineProperty(this, "_client", void 0);

    _defineProperty(this, "_userIdentifier", void 0);

    this._client = client;
    this._userIdentifier = userIdentifier;
  }

  _createClass(FeatureFlags, [{
    key: "getFlag",
    value: function getFlag(flagName, defaultValue, options) {
      return this._client.getFlagValue(flagName, defaultValue, options);
    }
  }, {
    key: "getAllFlags",
    value: function getAllFlags() {
      var flags = this._client.getFlags();

      var allFlags = {};
      allFlags = Object.keys(flags).reduce(function (flagsAll, key) {
        flagsAll[key] = flags[key].value;
        return flagsAll;
      }, allFlags);
      return Immutable.Map(allFlags);
    }
  }, {
    key: "changeUserIdentifier",
    value: function changeUserIdentifier(userId) {
      return this._client.updateFeatureFlagUser(userId);
    }
  }, {
    key: "resetUserIdentifier",
    value: function resetUserIdentifier() {
      return this._client.updateFeatureFlagUser(this._userIdentifier);
    }
  }]);

  return FeatureFlags;
}();

function getUser(userId, additionalIds) {
  var customAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var user;
  var tenantId = additionalIds === null || additionalIds === void 0 ? void 0 : additionalIds.tenantId;

  if (userId) {
    user = {
      identifier: {
        type: 'atlassianAccountId',
        value: userId
      },
      isAnonymous: false,
      additionalIdentifiers: {},
      custom: customAttributes
    };
  } else {
    user = {
      identifier: {
        type: 'ffClientAnonymousId',
        value: 'marketplace-anonymous'
      },
      isAnonymous: true,
      additionalIdentifiers: {},
      custom: customAttributes
    };
  }

  if (tenantId) {
    user.additionalIdentifiers.tenantId = tenantId;
  }

  return user;
}

function initFeatureFlagsClient(productKey, apiKey, environment, user, analyticsClient) {
  var clientOptions = {
    productKey: productKey,
    environment: environment
  };
  return new FeatureFlagWebClient(apiKey, analyticsClient, user, clientOptions);
}

export function getFeatureFlagsClient(_ref) {
  var apiKey = _ref.apiKey,
      environment = _ref.environment,
      userId = _ref.userId,
      additionalIds = _ref.additionalIds,
      analyticsClient = _ref.analyticsClient,
      productKey = _ref.productKey,
      customAttributes = _ref.customAttributes;
  var user = getUser(userId, additionalIds, customAttributes);
  var featureFlagsClient = initFeatureFlagsClient(productKey, apiKey, environment, user, analyticsClient);
  return featureFlagsClient.ready().then(function () {
    return new FeatureFlags(featureFlagsClient, user);
  });
}
export function makeTestFeatureFlags(flags) {
  return new FeatureFlags(new FrontendFeatureFlagsMockClient(flags), {
    identifier: {
      type: 'ffClientAnonymousId',
      value: 'marketplace-anonymous'
    },
    isAnonymous: true,
    additionalIdentifiers: {}
  });
}